<template>
  <v-system-bar
    height="30"
    v-if="userOnline"
    dark
    color="error"
    app
    fixed
    dense
    class="d-flex justify-center"
  >
    Modo sin conexion
  </v-system-bar>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("user", ["userOnline"])
  }
};
</script>
